export enum InsurerList {
    AIA = 2,
    FIDELITY = 3,
    ASTERON = 4,
    NIB = 5,
    PARTNERS_LIFE = 6,
    CHUBB_LIFE = 9,
    SOUTHERN_CROSS = 10,
    ACCURO = 11,
    CHUBB_LIFE_OLD = 81
}
